exports.isPasswordResetToken = token => (!!token.match(/^gwr_/));




// WEBPACK FOOTER //
// ./src/helpers/isPasswordResetToken.js